import React from 'react';
import { ActivityNoteDrawer } from '../shared/activity-drawer/ActivityNoteDrawer';
import { usePartnerDrawerAdapter } from './usePartnerDrawerAdapter';

interface PartnerStatusUpdateDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  partnerId: string;
  onNotesUpdated: () => void | Promise<void>;
  onActivityAdded?: () => void;
  onActivityUpdated?: () => void;
  translations: any;
  defaultTab?: 'note' | 'activity';
  editingActivity?: any;
  initialActivityData?: { title: string; type: string; description: string; due_date?: string; due_time?: string } | null;
  initialNoteText?: string | null;
  pipelineContext?: string;
}

/**
 * Task 5 "Partner drawer unificato": drawer Nota/Attività per un partner — gemello di
 * `LeadStatusUpdateDrawer.tsx` ma senza slot di stato ("Fase lead"): un partner non ha
 * fase/assegnatario/commerciale/motivo perso da modificare qui (la fase pipeline partner
 * si gestisce altrove, PartnerStageSlot Task 4). `statusSection` è quindi assente
 * (prop opzionale di `ActivityNoteDrawer`).
 *
 * Nasce perché montare `LeadStatusUpdateDrawer` per un partner scriverebbe (o, con la
 * guardia attuale, si limiterebbe a bloccare silenziosamente) su `lead_id` con l'id del
 * partner: `leadDrawerAdapter.linkageFields()` produce sempre `{ lead_id: leadId }`. Qui
 * l'adapter (`usePartnerDrawerAdapter`) produce invece `{ partner_id: partnerId }`, stessa
 * colonna già usata dal composer inline (`usePartnerComposerSaves`, Task 1) e da
 * `PartnerNotesSection`/`PartnerDetailsPage` (Task 2/5).
 */
export function PartnerStatusUpdateDrawer({
  isOpen,
  onClose,
  partnerId,
  onNotesUpdated,
  onActivityAdded,
  onActivityUpdated,
  translations,
  defaultTab = 'note',
  editingActivity,
  initialActivityData,
  initialNoteText,
  pipelineContext,
}: PartnerStatusUpdateDrawerProps) {
  const { adapter } = usePartnerDrawerAdapter({ partnerId, pipelineContext });

  return (
    <ActivityNoteDrawer
      isOpen={isOpen}
      onClose={onClose}
      adapter={adapter}
      defaultTab={defaultTab}
      editingActivity={editingActivity}
      initialActivityData={initialActivityData}
      initialNoteText={initialNoteText}
      translations={translations}
      onNotesUpdated={onNotesUpdated}
      onActivityAdded={onActivityAdded}
      onActivityUpdated={onActivityUpdated}
    />
  );
}

export default PartnerStatusUpdateDrawer;
